module.exports = __webpack_public_path__ + "static/explan.47ae85af.png";